export default "__VITE_ASSET__BJT42drk__"